// g-legal-line (CR-20261009-001 S1): the ClikHome legal line on a Canvas join and end page. Helix sends it with the
// create request and the meeting keeps it (legal_line); a meeting made before that has none and shows this fallback,
// which never carries a RERA part (D519). Pinned equal to Helix's legal_line.FALLBACK_TEXT by
// apps/helix/tests/test_legal_line.py::test_fallback_constants_agree. No DOM here: the pages set it with textContent.
export const LEGAL_FALLBACK = "Clikin.ai Platform Private Limited · CIN U62099KA2026PTC217033";

export function legalText(info) {
  const said = String(info?.legal ?? "").trim();
  return said || LEGAL_FALLBACK;
}
